export interface ITag {
  id: number;
  sequence: number;
  prefix: string;
}

export interface IHospitalResult {
  id: number;
  hospitalName?: string;
  createdDate?: string;
  hospitalUniqueName?: string | null;
  hospitalCloseDate?: string | null;
  isHospitalClosed?: boolean | null;
  recordCount?: number | null;
  hospitalLocation?: string | null;
}

export interface IHospitalParam {
  id?: number;
  hospitalName: string;
  hospitalAddress?: string;
  hospitalLocation?: string;
  isHospitalClosed?: boolean;
}

export interface IHospitalRecordResult {
  id: number;
  hospitalId: number;
  hospitalName: string;
  tagNumber: string;
  biomedicalDeviceDescription: string;
  brand: string;
  model: string;
  serialNumber: string;
  identificationNumber: string;
  location: string;
  note: string;
  responsiblePerson: string;
  addDate: Date;
  createdBy: string;
  color: string;
  tagNumberWithColor: string;
  tagSequence: number;
}

export interface IHospitalRecordParam {
  userId?: number;
  tagId?: number;
  tagSequence?: number;
  tagColor?: string; // Etiket rengi - red, yellow, green
  biomedicalDeviceDescription: string;
  brand: string;
  model: string;
  serialNumber: string;
  identificationNumber: string;
  location: string;
  note?: string;
  responsiblePerson: string;
  hospitalId: number;
  color?: string;
}

// Tag number color model (for listing color-specific sequences per tag)
export interface ITagNumberColor {
  id: number;
  tagNumberId: number;
  color: string;
  sequence: number;
}

export interface NewHospitalFormValues {
  hospitalName: string;
  hospitalAddress: string;
}

export const newHospitalInitialValues: NewHospitalFormValues = {
  hospitalName: '',
  hospitalAddress: '',
};

export interface NewTagNumberFormValues {
  hospitalId: number | null;
  prefix: string;
}

export const newTagNumberInitialValues: NewTagNumberFormValues = {
  hospitalId: null,
  prefix: '',
};

export interface SwitchHospitalFormValues {
  hospitalId: number | null;
  tagId: number | null;
}

export const switchHospitalInitialValues: SwitchHospitalFormValues = {
  hospitalId: null,
  tagId: null,
};

export interface NewRowManuelFormValues {
  tagColor: string;
  labelNo: number;
  deviceDefinition: string;
  brand: string;
  model: string;
  serialNumber: string;
  tagNumber: string;
  location: string;
  owner: string;
  notes: string;
  color: string;
}

export const getNewRowManuelInitialValues = (
  selectedTagColor: string,
  getNextLabelForColor: (color: string) => number
): NewRowManuelFormValues => ({
  tagColor: selectedTagColor,
  labelNo: getNextLabelForColor(selectedTagColor),
  deviceDefinition: '',
  brand: '',
  model: '',
  serialNumber: '',
  tagNumber: '',
  location: '',
  owner: '',
  notes: '',
  color: selectedTagColor,
});

export const TAG_COLOR_OPTIONS = [
  { value: 'red', label: 'Kırmızı Etiket' },
  { value: 'yellow', label: 'Sarı Etiket' },
  { value: 'green', label: 'Yeşil Etiket' },
];
